import React, { PropTypes } from 'react';
import bemHelper from 'react-bem-helper';
import dateformat from 'dateformat';

import ReadMore from './ReadMore';
import * as constants from '../../constants';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-comment' });

export default class Comment extends ReadMore {

  render() {
    const { comment } = this.props;
    const classes = this.getClasses();
    return (
      <article {...bem(null, classes)}>
        <div {...bem('info', classes)}>
          <div
            ref="textContainer"
            onMouseLeave={this.onMouseLeaveHandler.bind(this)}
            {...bem('text', classes)}>
            <span {...bem('quot_left', classes)}>"</span>
            {comment.comment}
            <span {...bem('quot_right', classes)}>"</span></div>
          <div {...bem('read-more', classes)}
               onClick={this.onMouseOverHandler.bind(this)}>read more
          </div>
          <p {...bem('date', classes)}>{dateformat(comment.date, constants.REVIEW_DATE_FORMAT)}</p>
        </div>
        <div {...bem('press-container')}>
          {comment.link ?
            <a {...bem('press-link')} target="_blank" href={comment.link}>{comment.name}</a>
            :
            <p {...bem('press-company')}>{comment.name}</p>
          }
          <p {...bem('press-name') }>{comment.author}</p>
        </div>
      </article>
    );
  }
}

Comment.PropTypes = {
  text: PropTypes.string,
  date: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/storefront/components/Comment/Comment.js